import { render, staticRenderFns } from "./InvTypeModal.vue?vue&type=template&id=542a94f6&"
import script from "./InvTypeModal.vue?vue&type=script&lang=js&"
export * from "./InvTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./InvTypeModal.vue?vue&type=style&index=0&id=542a94f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports